import useFilters from 'modules/core/components/DataTable/hooks/useFilters'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'
import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'

import { buildBankAccountsTransactionsInsightWidget } from '../Widgets/BankAccountsTransactionsWidget'

interface AccountTransactionsInsightsProps {
  currency: string
  locale: string
  accountIds?: number[]
  description?: string
}

export const AccountTransactionsInsights = ({
  currency,
  locale,
  accountIds = [],
  description,
}: AccountTransactionsInsightsProps) => {
  const { getFiltersVariables } = useFilters()

  const amountFormatter = (value: unknown) =>
    formattedAmount({ amountCents: Number(value), currency: currency, locale: locale })
  const dataTableFilters = getFiltersVariables().filter ?? {}
  const allFilters = {
    ...dataTableFilters,
    bankAccountId: { in: accountIds },
    ...(description !== undefined && { description: { eq: description } }),
  }

  return (
    <DataTableWidgetInsights
      widgets={[
        buildBankAccountsTransactionsInsightWidget({
          filters: allFilters,
          prepareDataArgs: { amountFormatter },
        }),
      ]}
      widgetWidth="full"
    />
  )
}
